<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import PublicSiteFooter from '@/components/publicSite/PublicSiteFooter.vue'
import PublicSiteHeader from '@/components/publicSite/PublicSiteHeader.vue'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { t } = useI18n({ useScope: 'global' })
const route = useRoute()

const isLoading = ref(true)
const success = ref(false)
const email = ref('')

onMounted(async () => {
  try {
    const data = await $api<{ success: boolean, email?: string }>(`/public/newsletter/unsubscribe/${route.params.token}`)
    success.value = !!data.success
    email.value = data.email || ''
  } catch {
    success.value = false
  } finally {
    isLoading.value = false
  }
})
</script>

<template>
  <div class="unsubscribe-premium">
    <PublicSiteHeader />

    <section class="unsubscribe-section">
      <div class="container text-center">
        <div class="unsubscribe-card">
          <div v-if="isLoading" class="d-flex justify-center py-8">
            <VProgressCircular indeterminate color="primary" size="40" />
          </div>
          <template v-else-if="success">
            <VIcon icon="tabler-mail-off" size="48" color="primary" class="mb-4" />
            <h1 class="text-h4 font-weight-bold result-title mb-3">{{ t('publicSite.newsletter.unsubscribeSuccessTitle') }}</h1>
            <p class="result-text">{{ t('publicSite.newsletter.unsubscribeSuccessText', { email }) }}</p>
          </template>
          <template v-else>
            <VIcon icon="tabler-alert-triangle" size="48" color="warning" class="mb-4" />
            <h1 class="text-h4 font-weight-bold result-title mb-3">{{ t('publicSite.newsletter.unsubscribeErrorTitle') }}</h1>
            <p class="result-text">{{ t('publicSite.newsletter.unsubscribeErrorText') }}</p>
          </template>
          <VBtn color="primary" to="/" class="mt-6 text-none font-weight-bold">{{ t('publicSite.shared.backToHome') }}</VBtn>
        </div>
      </div>
    </section>

    <PublicSiteFooter />
  </div>
</template>

<style scoped>
.unsubscribe-premium {
  font-family: 'Outfit', sans-serif;
  background-color: #0F172A;
  color: #F1F5F9;
  min-height: 100vh;
}

.container { max-width: 680px; margin: 0 auto; padding: 0 40px; }

.unsubscribe-section { padding: 120px 0; }

.unsubscribe-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 28px;
  padding: 48px 40px;
}

.result-title { color: #FFFFFF; }
.result-text { color: #CBD5E1; }

@media (max-width: 600px) {
  .container { padding: 0 20px; }
  .unsubscribe-card { padding: 32px 24px; }
}
</style>
